import { AgTechGridControlProps } from "../Data/AgTechGridProps";
import { useState, useEffect, useRef } from "react";

export const AgTechGridToggleControl = (props: React.PropsWithChildren<AgTechGridControlProps<boolean>>) => {
    let [controlValue, setControlValue] = useState(props.value);
    let lastValue = useRef(props.value);

    useEffect(() => {
        if (props.value !== controlValue) {
            setControlValue(props.value);
            lastValue.current = props.value;
        }
    }, [props]);

    return (
        <div className="centered flex" style={{ maxWidth: 'unset' }}>
            <input
                type="checkbox"
                className={`p-2 w-[14px] h-[14px] ${controlValue ? 'bg-highlight' : ''}`}
                tabIndex={props.readonly ? -1 : 0}
                checked={controlValue}
                disabled={props.readonly}
                onChange={e => {
                    setControlValue(!lastValue.current);

                    if (props.onUpdated) {
                        lastValue.current = !lastValue.current;
                        props.onUpdated(lastValue.current);
                    } 
                }}
                onFocus={e => e.stopPropagation()}
            />
        </div>
    )
}